import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  updateTabData,
  applyFilters,
  handleTabsFilterChange,
  handleTagsFiltersChange,
  handleSearchFiltersChange,
  addInvestorsFilesToStoreService,
} from './fileTagging.service';
import { FileTagsValues } from 'src/types.d';
import { toast, ToastOptions } from 'react-toastify';
import { FileTagEnum } from 'src/generated/graphql-types';

const initialState = {
  newFiles: [],
  taggedFilesArray: [],
  allFiles: [],
  filesForView: [],
  activeFilters: [{ key: 'selected_tab', value: FileTagEnum.Investor }],
  selectedTab: 0,
  untaggedCounter: 0,
  investorsFilesCounter: 0,
};
export const tabs = [
  { type: FileTagEnum.Investor, label: 'fileTagging.tabs.investors' },
  { type: FileTagsValues.UNTAGGED, label: 'fileTagging.tabs.untagged' },
];

//todo nir file upload toast file
export const uploadFile: any = createAsyncThunk(
  'fileTagging/uploadFile',
  async (args: any, thunkAPI) => {
    let res: any = {
      requestParams: args.data,
    };
    const options: ToastOptions = {
      autoClose: 7000,
      type: toast.TYPE.INFO,
      position: 'top-right',
      pauseOnHover: true,
    };

    return;
  },
);

const fileTaggingSlice = createSlice({
  name: 'fileTagging',
  initialState,
  reducers: {
    resetfilters(state, { payload }: PayloadAction<any>) {
      state.activeFilters = [{ key: 'selected_tab', value: FileTagEnum.Investor }];
    },
    updateSearchFilter(state, { payload }: PayloadAction<any>) {
      state.untaggedCounter = 0;
      state.investorsFilesCounter = 0;
      state.activeFilters = handleSearchFiltersChange(state.activeFilters, payload.searchString);
      state.filesForView = applyFilters(state.allFiles, state.activeFilters, [], false, state);
    },
    updateTagsFilter(state, { payload }: PayloadAction<any>) {
      state.untaggedCounter = 0;
      state.investorsFilesCounter = 0;
      state.activeFilters = handleTagsFiltersChange(state.activeFilters, payload.tagData);
      state.filesForView = applyFilters(
        state.allFiles,
        state.activeFilters,
        state.filesForView,
        false,
        state,
      );
    },
    updateTabFilter(state, { payload }: PayloadAction<any>) {
      state.untaggedCounter = 0;
      state.investorsFilesCounter = 0;
      state.activeFilters = handleTabsFilterChange(state.activeFilters, payload.selectedTab);
      state.filesForView = applyFilters(
        state.allFiles,
        state.activeFilters,
        state.filesForView,
        false,
        state,
      );
    },
    clearAllFiles(state, { payload }: PayloadAction<any>) {
      state.allFiles = [];
    },
    clearNewFiles(state, { payload }: PayloadAction<any>) {
      state.newFiles = [];
    },
    clearfilesForView(state, { payload }: PayloadAction<any>) {
      state.filesForView = [];
    },
    updateTaggedFilesArray(state, { payload }: PayloadAction<any>) {
      state.taggedFilesArray = payload.reset
        ? []
        : updateTabData(
            payload.selectedTabType,
            payload.files,
            state.taggedFilesArray,
            payload.isTabChanged,
          );
    },
    updateSelectedTab(state, { payload }: PayloadAction<any>) {
      state.selectedTab = payload;
    },
    updateInvestorsFilesCounter(state, { payload }: PayloadAction<any>) {
      state.investorsFilesCounter = payload;
    },
    updateUntaggedCounter(state, { payload }: PayloadAction<any>) {
      state.untaggedCounter = payload;
    },
    // setUntaggedFiles(state, { payload }: PayloadAction<any>) {
    //   addNewFileToStoreService(state, payload);
    // },
    setTaggedFiles(state, { payload }: PayloadAction<any>) {
      addInvestorsFilesToStoreService(state, payload);
    },
  },
});

export const {
  updateTaggedFilesArray,
  clearAllFiles,
  resetfilters,
  updateTabFilter,
  updateTagsFilter,
  updateSearchFilter,
  updateSelectedTab,
  updateUntaggedCounter,
  updateInvestorsFilesCounter,
  // setUntaggedFiles,
  setTaggedFiles,
  clearfilesForView,
  clearNewFiles,
} = fileTaggingSlice.actions;

export default fileTaggingSlice.reducer;
